// extracted by mini-css-extract-plugin
module.exports = {"zoomSliderContainer":"ZoomSlider_zoomSliderContainer__WBUxz","zoomText":"ZoomSlider_zoomText__a97Fg","zoomContainer":"ZoomSlider_zoomContainer__2IhW5"};